<template>
  <div>
    <div class="l-bg-white row jobs-edit">
      <div class="col-12 col-lg-9 col-xl-9">
        <template v-if="!job.ref_id">
          <content-loader />
        </template>
        <template v-else>
          <div class="row d-flex bg-grey py-2 header-edit">
            <div class="col-5 col-xl-10 col-md-10 col-lg-10">
              <div class="row align-items-center">
                <JobStatus
                  v-if="job.status_id !== ''"
                  :lead-source="leadSource ? leadSource : {}"
                  :ref-id="job.ref_id"
                  :status="job.status"
                  :source="job.source"
                  :is-flat-rate="isFlatRate"
                />
                <JobMoveInfo :job="job" />
              </div>
            </div>
            <JobInfo
              @createClaim="newClaim = true"
              @showCarrierReassignModal="
                showCarrierReassignModal = true;
                getCarriers();
              "
              @showModalCancelJob="showModalCancelJob = true"
              @showModalAcceptJob="showModalAcceptJob = true"
              @showModalIsSmallJob="showModalIsSmallJob = true"
              @showModalRejectJob="showModalRejectJob = true"
              @changeToInProgress="changeStatus(job.id, 40)"
              @changeToOnHold="changeStatus(job.id, 21)"
              @showRevertToAccepted="showAreYouSureRevertModal = true"
              @showRevertToTotalTime="showAreYouSureRevertTotalTimeModal = true"
              @showSendEpayLink="showSendEpayLinkModal = true"
              @returnToPending="changeStatus(job.id, 2)"
              @reassignUserModal="reassignUserModal()"
              @getJob="getJob"
              @movingContractSent="movingContractSent"
              @toggleEmailConfirmationModal="toggleEmailConfirmationModal"
              :show-moving-contract-button="showMovingContractButton"
              :show-email-confirmation-modal="showEmailConfirmationModal"
              :has-access="userHasAccessToCarrier"
              :changes="changes"
              :job="job"
            />
          </div>
          <div
            v-if="job.rejection_status_log && job.rejection_status_log.note && job.status_id === 31"
            class="row"
          >
            <div class="col-md-12 mt-3">
              <div class="ml-4 d-flex align-items-center alert alert-rejection border-0">
                <span class="mod-icon-rejected-job mr-2" />
                <span class="acknowledge-msg">
                  <strong>Rejection reason:</strong>
                  {{ job.rejection_status_log.note }}
                </span>
              </div>
            </div>
          </div>
          <JobDetails :job="job" />
          <JobCustomerInfo
            v-if="job.customer"
            :job="job"
            :user-id="user.id"
            :has-access="userHasAccessToCarrier"
            :customer-note="customerNote"
            @review="companyReviewModal = !companyReviewModal"
            @showCustomerModal="showCustomerModal = !showCustomerModal"
            @saveCustomerNote="callback => saveCustomerNote(callback)"
          />
          <div v-else style="background-color: #f8d7d9" class="p-3 mx-5 mb-3">
            <h6>
              Deleted <br />
              Customer
            </h6>
          </div>
          <HeavyItemsDisclaimer
            :company-heavy-items-fee="job.company.heavy_items_fee"
            :editable="isActive"
            :has-heavy-items="job.has_heavy_items"
            :job-id="job.id"
            :model-heavy-items-fee="job.heavy_items_fee"
            @getJob="getJob"
          />
          <div
            v-if="$_can('tags.show')"
            class="px-5 d-flex align-items-center justify-content-start flex-wrap mb-3"
          >
            <tag-color
              v-for="tag in job.company.tags"
              :key="tag.id"
              :color="tag.color.name"
              :name="tag.name"
              input-class="mr-3"
            />
          </div>
          <div class="py-3" v-if="hasClaim">
            <JobClaimBanner :claim="job.claim" />
          </div>

          <div class="py-3" v-if="job.ratings && job.ratings.length">
            <JobRating :ratings="job.ratings" @getJob="getJob()" />
          </div>

          <JobRates
            :job="job"
            :config="config"
            :edited-field="editedField"
            :editable-fields="editableFields"
            :arrival-windows="arrival_windows"
            :move-sizes="move_sizes"
            :number-of-movers="numberOfMovers"
            :is-small-job="isSmallJob"
            :has-access="userHasAccessToCarrier"
            @editedField="editedField = true"
            @editableFields="editableFields = true"
            @getJob="getJob"
            @save="save"
          />

          <!-- Tabs -->
          <JobsTabs :job-tab-step="jobTabStep" :plans="plans" @jobTabStep="setJobTabStep" />

          <JobsTabsContent
            :job="job"
            :job-loading="jobLoading"
            :job-tab-step="jobTabStep"
            :edited-field="editedField"
            :loading-discard-button="loadingDiscardButton"
            :button-disabled="buttonDisabled"
            :has-access="userHasAccessToCarrier"
            :deleted-locations="deletedLocations"
            @getJob="getJob"
            @editedField="editedField = true"
            @loadingDiscardButton="loadingDiscardButton = true"
            @buttonDisabled="buttonDisabled = true"
            @sendAutomaticMessages="sendAutomaticMessagesMethod"
            @openAssignedMoversModal="openAssignedMoversModal"
            @openAssignedTrucksModal="openAssignedTrucksModal"
            @save="save"
            @discardJob="discardJob"
            @jobTabStep="setJobTabStep"
          />
        </template>
      </div>

      <!-- Right Sidebar -->
      <div class="col-12 col-lg-3 col-xl-3 complete-job-sidebar border-left pl-3 pr-5">
        <div class="row">
          <div class="col-12 nav nav-tabs nav-fill p-0">
            <div
              :class="[rightSidebarTab === 'notes' ? 'active' : '']"
              class="col-6 nav-item nav-link pointer"
              @click="rightSidebarTab = 'notes'"
            >
              Comments
            </div>
            <div
              :class="[rightSidebarTab === 'priceBreakdown' ? 'active' : '']"
              class="col-6 nav-item nav-link pointer"
              @click="rightSidebarTab = 'priceBreakdown'"
            >
              Billing
            </div>
          </div>
        </div>

        <div v-if="rightSidebarTab === 'notes'">
          <div class="row notes-box pt-3">
            <div class="col-12 single-note pb-4" v-for="note in job.notes" :key="note.id">
              <div
                class="border rounded m-0 p-2"
                v-if="typeof note.note === 'string' && note.note.length > 0"
              >
                <strong class="d-block" v-if="note.user.first_name">
                  {{ note.user.first_name }} {{ note.user.last_name }}
                </strong>
                <strong class="d-block" v-else>customer</strong>
                <p>{{ note.note }}</p>
                <span class="small">{{ note.date }}</span>
              </div>
            </div>
            <!-- cancellation note -->
            <div
              class="col-12 pb-4"
              v-if="cancellationNote && job.status && job.status.name === 'Canceled'"
            >
              <div class="rounded m-0 p-2  single-note-cancelled">
                <div class="text-danger text-right">
                  <small><strong>JOB CANCELLED</strong></small>
                </div>
                <strong v-if="cancellationNote.cluster_user">
                  {{ cancellationNote.cluster_user.first_name }}
                  {{ cancellationNote.cluster_user.last_name }}
                </strong>
                <strong v-else>
                  Customer
                </strong>
                <p>{{ cancellationNote.note }}</p>
                <span class="small">{{ cancellationNote.created_at }}</span>
              </div>
            </div>
          </div>
          <div
            class="row pt-2 px-2 mb-2 mx-0 fixed-bottom border-top position-absolute notes-field bg-white"
          >
            <div class="col-10 px-0">
              <div class="border w-100 text-field" v-if="editNote">
                <textarea v-auto-resize v-model="job.note" />
              </div>
              <div class="border w-100 text-field" v-else>
                <textarea v-auto-resize @click="editNote = true" />
              </div>
            </div>
            <div class="col-2 pointer px-0">
              <button class="btn btn-primary pt-2" :disabled="editNote === false" @click="saveNote">
                <span class="mod-icon-note" />
              </button>
            </div>
          </div>
        </div>

        <div v-if="rightSidebarTab === 'priceBreakdown'" class="w-100">
          <div class="row mt-4">
            <div class="col-6">
              <div class="select-wrap">
                <label>Total job time</label>
                <input-time
                  v-model="job.job_time"
                  v-if="configTimepicker"
                  :minute-interval="configTimepicker.minuteInterval"
                  @close="saveJobTime"
                />
              </div>
            </div>
            <div class="col-6">
              <h5>Price</h5>
              <span v-if="isFlatRate"> $ {{ job.price }} </span>
              <span v-else> $ {{ job.price_per_hour }} </span>
            </div>
          </div>
          <div v-if="job.company.double_drive" class="row mt-4">
            <div class="col-6">
              <div class="select-wrap">
                <label>DDT</label>
                <input-time
                  v-model="job.double_drive_time"
                  v-if="ddTimeConfig"
                  :minute-interval="ddTimeConfig.minuteIncrement"
                  @close="saveDdTime"
                />
              </div>
            </div>
          </div>

          <div class="row mt-4 mb-2" v-if="job && job.total_hours">
            <div class="col-7 p-3 bg-grey">
              <h4><strong>Total job time</strong></h4>
            </div>
            <div class="col-5 p-3 bg-grey flex justify-content-end">
              <h4>
                <strong>{{ job.total_hours }}</strong>
              </h4>
            </div>
          </div>
          <template v-if="job && job.total_time">
            <div class="row mb-2">
              <div class="col-7">
                <h5 class="d-inline">Total duration</h5>
              </div>

              <div class="col-5 text-right">
                {{ job.total_time }}
              </div>
            </div>
            <div class="row mb-2" v-if="job.double_drive_added">
              <div class="col-7">
                <h5 class="d-inline">DDT</h5>
              </div>

              <div class="col-5 text-right">
                {{ job.double_drive_time }}
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <h5 class="d-inline">Total breaks</h5>
              </div>

              <div class="col-5 text-right">
                {{ job.breaks }}
              </div>
            </div>
          </template>

          <div class="row mt-4 mb-2">
            <div class="col-12 p-3 bg-grey">
              <h4><strong>Price breakdown</strong></h4>
            </div>
          </div>
          <div class="row mb-2 base-price" v-if="!isFlatRate">
            <div class="col-7">
              <p>
                Base price
                <span
                  class="btn-status btn-booked px-3"
                  v-if="job.job_time < job.minimum_hours && jobStatus"
                >
                  (min hours charged)</span>
              </p>
            </div>
            <div class="col-5 text-right">
              <p>$ {{ job.base_price }}</p>
            </div>
          </div>
          <div class="row mt-4 mb-2">
            <div class="col-7">
              <h4
                class="pointer"
                @click="additionalExpensesToggleAddition = !additionalExpensesToggleAddition"
              >
                <i
                  class="fa text-secondary"
                  aria-hidden="true"
                  :class="
                    additionalExpensesToggleAddition ? 'fa fa-caret-down' : 'fa fa-caret-right'
                  "
                />
                <strong class="pl-1">
                  Additional expenses
                </strong>
              </h4>
            </div>
            <div class="col-5 text-right">
              <strong>$ {{ job.total_expenses }}</strong>
            </div>
          </div>
          <template v-if="additionalExpensesToggleAddition">
            <template v-if="expenses">
              <div class="row" v-for="(expense, index) in expenses" :key="expense.id">
                <template v-if="editableExpenseAddition[index]">
                  <div v-if="expense.type_id === 1" class="col-7 pr-1">
                    <div class="border rounded amount-wrap-small">
                      <input
                        type="text"
                        class="form-control p-1"
                        placeholder="Expense name"
                        v-model="expense.name"
                        :disabled="!editableExpenseAddition[index]"
                      />
                      <button
                        type="button"
                        class="btn input-group-btn edit-transaction-remove"
                        @click="editExpenseAddition(index)"
                      >
                        <i class="fa fa-remove" />
                      </button>
                    </div>
                  </div>
                  <div v-if="expense.type_id !== 1" class="col-7 pr-1">
                    <div class="border rounded amount-wrap-small">
                      <simple-select
                        class="form-control p-1 small-simple-select"
                        placeholder="Tip type"
                        :options="tipType.filter(type => type.id !== 1)"
                        v-model="expense.type_id"
                        :hide-select="true"
                        :disabled="!editableExpenseAddition[index]"
                      />
                      <button
                        type="button"
                        class="btn input-group-btn edit-transaction-remove close-tips"
                        @click="editExpenseAddition(index)"
                      >
                        <i class="fa fa-remove" />
                      </button>
                    </div>
                  </div>
                  <div class="col-3 px-1">
                    <div class="border rounded amount-wrap-small amount-field">
                      <span class="dollar">$</span>
                      <input
                        type="text"
                        class="form-control"
                        v-model="expense.amount"
                        placeholder="Amount"
                        @keydown="clearError($event)"
                        :disabled="!editableExpenseAddition[index]"
                      />
                    </div>
                    <error-field :errors="errors" field="amount" />
                  </div>
                  <div class="col-1 px-1">
                    <template v-if="$_can('job-expenses.update')">
                      <button
                        type="button"
                        class="btn btn-save"
                        @click="saveEditedExpense(index, expense)"
                        v-if="editableExpenseAddition[index]"
                      >
                        <span class="mod-icon-save" />
                      </button>
                      <button
                        type="button"
                        class="btn btn-edit"
                        @click="editExpenseAddition(index)"
                        v-else
                      >
                        <span class="mod-icon-expense-edit" />
                      </button>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="col-5">
                    <h5>{{ expense && expense.name }}</h5>
                  </div>
                  <div class="col-5 text-right">$ {{ expense.amount }}</div>
                  <div
                    class="col-2 text-right pointer"
                    v-if="jobIsEditable && expense.is_editable === 1"
                  >
                    <div
                      id="dropdownMenuButtonEditExpenseAddition"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-h text-secondary" aria-hidden="true" />
                    </div>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButtonEditExpenseAddition"
                    >
                      <a class="dropdown-item p-1 small" @click="editExpenseAddition(index)">
                        Edit</a>
                      <a class="dropdown-item p-1 small" @click="removeExpense(index, expense.id)">
                        Delete</a>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <!-- new -->
            <div
              class="row"
              v-if="$_can('job-expenses.store') && addingNewAdditionalExpense === true"
            >
              <div class="col-7 pr-1">
                <div class="border rounded amount-wrap-small">
                  <input
                    type="text"
                    class="form-control p-1"
                    placeholder="Expense name"
                    v-model="newExpense.name"
                    @keydown="clearError($event)"
                  />
                  <button
                    type="button"
                    class="btn input-group-btn edit-transaction-remove"
                    @click="addingNewAdditionalExpense = false"
                  >
                    <i class="fa fa-remove" />
                  </button>
                </div>
              </div>
              <div class="col-3 px-1">
                <div class="border rounded amount-wrap-small">
                  <span class="dollar">$</span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="newExpense.amount"
                    placeholder="Amount"
                    @keydown="clearError($event)"
                  />
                </div>
                <error-field :errors="errors" field="amount" />
              </div>
              <div class="col-1 pt-1">
                <button type="button" class="btn btn-save" @click="saveExpense(1, false)">
                  <span class="mod-icon-save" />
                </button>
              </div>
            </div>
            <div class="row" v-if="$_can('jobs.tips.store') && addingNewMoverTips === true">
              <div class="col-7 pr-1">
                <div class="border rounded amount-wrap-small position-relative">
                  <simple-select
                    class="form-control p-1 small-simple-select"
                    placeholder="Tip type"
                    :options="tipType.filter(type => type.id !== 1)"
                    v-model="newExpense.type_id"
                    :hide-select="true"
                  />
                </div>
                <button
                  type="button"
                  class="btn input-group-btn edit-transaction-remove close-tips"
                  @click="addingNewMoverTips = false"
                >
                  <i class="fa fa-remove" />
                </button>
              </div>
              <div class="col-3 px-1">
                <div class="border rounded amount-wrap-small amount-field">
                  <span class="dollar">$</span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="newExpense.amount"
                    placeholder="Amount"
                    @keydown="clearError($event)"
                  />
                </div>
                <error-field :errors="errors" field="amount" />
              </div>
              <div class="col-1 pt-1">
                <button type="button" class="btn btn-save" @click="saveExpense(1, true)">
                  <span class="mod-icon-save" />
                </button>
              </div>
            </div>
            <div class="row mt-2" v-if="addingNewAdditionalExpense === false">
              <div class="col-12">
                <button
                  type="button"
                  class="add-button pointer pull-right"
                  :class="{ disabled: !userHasAccessToCarrier || isFlatRate }"
                  :disabled="!userHasAccessToCarrier || isFlatRate"
                  v-if="$_can('job-expenses.store') && canEditJob"
                  @click="addingNewExpense('additional')"
                >
                  Add expenses
                  <span class="ml-2 mr-0"><span class="mod-icon-add" /></span>
                </button>
              </div>
            </div>
            <div class="row mt-2" v-if="addingNewMoverTips === false">
              <div class="col-12 mt-3">
                <button
                  type="button"
                  class="add-button pointer pull-right"
                  :class="{ disabled: !userHasAccessToCarrier || isFlatRate }"
                  :disabled="!userHasAccessToCarrier || isFlatRate"
                  v-if="$_can('jobs.tips.store') && canAddTips"
                  @click="addingNewExpense('tips')"
                >
                  Add tips
                  <span class="ml-2 mr-0"><span class="mod-icon-add" /></span>
                </button>
              </div>
            </div>
          </template>
          <div class="row mt-4 mb-2">
            <div class="col-7">
              <h4
                class="pointer"
                @click="additionalExpensesToggleDiscount = !additionalExpensesToggleDiscount"
              >
                <i
                  class="fa text-secondary"
                  aria-hidden="true"
                  :class="
                    additionalExpensesToggleDiscount ? 'fa fa-caret-down' : 'fa fa-caret-right'
                  "
                />
                <strong class="pl-1">
                  Discount
                </strong>
              </h4>
            </div>
            <div class="col-5 text-right">
              <strong>- $ {{ job.total_discounts }}</strong>
            </div>
          </div>
          <template v-if="additionalExpensesToggleDiscount">
            <template v-if="expenses">
              <div class="row" v-for="(expense, index) in discounts" :key="expense.id">
                <template v-if="editableExpenseDiscount[index]">
                  <div class="col-5 pr-1">
                    <div class="border rounded amount-wrap-small">
                      <input
                        type="text"
                        class="form-control p-1"
                        placeholder="Discount name"
                        v-model="expense.name"
                        :disabled="!editableExpenseDiscount[index]"
                      />
                      <button
                        type="button"
                        class="btn input-group-btn edit-transaction-remove"
                        @click="editExpenseDiscount(index)"
                      >
                        <i class="fa fa-remove" />
                      </button>
                    </div>
                  </div>
                  <div class="col-3 pr-1">
                    <div class="border rounded">
                      <input
                        type="text"
                        class="form-control pl-1"
                        v-model="expense.amount"
                        placeholder="Amount"
                        @keydown="clearError($event)"
                        :disabled="!editableExpenseDiscount[index]"
                      />
                    </div>
                    <error-field :errors="errors" field="amount" />
                  </div>
                  <div class="col-4">
                    <div class="border rounded amount-wrap-small">
                      <simple-select
                        class="form-control p-1 small-simple-select"
                        placeholder="Discount type"
                        :options="discountUnitTypes"
                        v-model="expense.discount_unit_type_id"
                        :hide-select="true"
                      />
                    </div>
                    <error-field :errors="errors" field="discount_unit_type_id" />
                  </div>
                  <div class="col-8 mt-1 pr-1 mb-3">
                    <div class="border rounded amount-wrap-small">
                      <simple-select
                        class="form-control p-1 small-simple-select"
                        placeholder="Discount type"
                        :options="discountTypes"
                        v-model="expense.type_id"
                        :hide-select="true"
                        :disabled="
                          !editableExpenseDiscount[index] || !$_can('job-discounts.change-type')
                        "
                      />
                    </div>
                  </div>
                  <div class="col-4 pt-2 d-flex justify-content-end">
                    <template v-if="$_can('job-discounts.update')">
                      <button
                        type="button"
                        class="btn btn-save"
                        @click="saveEditedDiscount(index, expense.id)"
                        v-if="editableExpenseDiscount[index]"
                      >
                        <span class="mod-icon-save" />
                      </button>
                      <button
                        type="button"
                        class="btn btn-edit"
                        @click="editExpenseDiscount(index)"
                        v-else
                      >
                        <span class="mod-icon-expense-edit" />
                      </button>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="col-6">
                    <h5>{{ expense && expense.name }} ({{ expense.type.name }})</h5>
                  </div>
                  <div class="col-4 text-right">
                    <template v-if="expense.discount_unit_type_id === 1">
                      - $ {{ expense.amount }}
                    </template>
                    <template v-else-if="expense.discount_unit_type_id === 2">
                      - $ {{ expense.calculated_amount }} ({{ expense.amount }}%)
                    </template>
                  </div>
                  <div
                    class="col-2 text-right pointer"
                    v-if="
                      !expense.is_editable &&
                        !expense.is_likes_discount &&
                        !expense.from_subscription &&
                        $_can('jobs.discount.cash.remove')
                    "
                  >
                    <div
                      id="dropdownMenuButtonEditExpenseDiscount1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-h text-secondary" aria-hidden="true" />
                    </div>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButtonEditExpenseDiscount1"
                    >
                      <a class="dropdown-item p-1 small" @click="showClearCashDiscountModal = true">
                        Delete</a>
                    </div>
                  </div>
                  <div
                    class="col-2 text-right pointer"
                    v-if="jobIsEditable && expense.is_editable === 1"
                  >
                    <div
                      id="dropdownMenuButtonEditExpenseDiscount"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-h text-secondary" aria-hidden="true" />
                    </div>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButtonEditExpenseDiscount"
                    >
                      <a class="dropdown-item p-1 small" @click="editExpenseDiscount(index)">
                        Edit</a>
                      <a class="dropdown-item p-1 small" @click="removeDiscount(index, expense.id)">
                        Delete</a>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <!-- new -->
            <!--            <div class="row" v-if="$_can('job-discounts.store') && addingNewDiscountExpense === true">-->
            <div
              class="row mt-3 pt-3 border-top"
              v-if="
                ($_can('jobs.discount.add.carrier.covered') ||
                  $_can('jobs.discount.add.office.covered') ||
                  $_can('jobs.discount.add.general.covered')) &&
                  addingNewDiscountExpense === true
              "
            >
              <div class="col-5 pr-1">
                <div class="border rounded amount-wrap-small">
                  <input
                    type="text"
                    class="form-control p-1"
                    placeholder="Discount name"
                    v-model="newDiscount.name"
                    @keydown="clearError($event)"
                  />
                  <button
                    type="button"
                    class="btn input-group-btn edit-transaction-remove"
                    @click="addingNewDiscountExpense = false"
                  >
                    <i class="fa fa-remove" />
                  </button>
                </div>
              </div>
              <div class="col-3 pr-1">
                <div class="border rounded">
                  <input
                    type="text"
                    class="form-control pl-1"
                    v-model="newDiscount.amount"
                    placeholder="Amount"
                    @keydown="clearError($event)"
                  />
                </div>
                <error-field :errors="errors" field="amount" />
              </div>
              <div class="col-4">
                <div class="border rounded amount-wrap-small pr-2">
                  <simple-select
                    v-model="newDiscount.discount_unit_type_id"
                    :hide-deselect="true"
                    class="form-control p-1 small-simple-select"
                    :options="discountUnitTypes"
                    label="name"
                    placeholder="Unit"
                    @input="errors.clear('discount_unit_type_id')"
                  />
                </div>
                <error-field :errors="errors" field="discount_unit_type_id" />
              </div>
              <div class="col-12 d-flex justify-content-end pt-2">
                <button type="button" class="btn btn-save" @click="saveDiscount">
                  <span class="mod-icon-save" />
                </button>
              </div>
            </div>
            <div class="row mt-2" v-else>
              <div class="col">
                <button
                  type="button"
                  class="add-button pointer pull-right"
                  :class="{ disabled: !userHasAccessToCarrier || isFlatRate }"
                  :disabled="!userHasAccessToCarrier || isFlatRate"
                  v-if="
                    ($_can('jobs.discount.add.carrier.covered') ||
                      $_can('jobs.discount.add.office.covered') ||
                      $_can('jobs.discount.add.general.covered')) &&
                      canEditJob
                  "
                  @click="addingNewExpense('discount')"
                >
                  Add discount
                  <span class="ml-2 mr-0"><span class="mod-icon-add" /></span>
                </button>
              </div>
            </div>
          </template>
          <div class="row mt-4 mb-2">
            <div class="col-12 p-3 bg-grey">
              <h4><strong>Transactions</strong></h4>
            </div>
          </div>
          <template v-if="job && job.charges">
            <div
              class="row"
              v-for="(transaction, index) in job.charges.filter(el => el.payment_type_id === 3)"
              :key="`trans-prefix-3-${index}`"
            >
              <div class="col-7">
                <h5 class="d-inline">{{ transaction.payment_type.name }}</h5>
                <div
                  class="btn btn-link p-0 tippy-popup m-0"
                  @mouseover="$set(showTooltipTransactions, index, true)"
                  @mouseout="$set(showTooltipTransactions, index, false)"
                >
                  <i class="fa fa-info-circle" />
                </div>
                <div
                  class="popover popover-transaction tippy-info-popover"
                  v-if="showTooltipTransactions[index]"
                >
                  <div>{{ transaction.date }}</div>
                  <div>
                    {{ transaction.payment_method.name }}
                    {{
                      transaction.payment_method_id === 4 && '(**** ' + transaction.card.last4 + ')'
                    }}
                  </div>
                  <div>{{ transaction.note }}</div>
                </div>
              </div>
              <div class="col-5 text-right">$ {{ transaction.amount }}</div>
            </div>
          </template>
          <div class="row mt-4 mb-2">
            <div class="col-7">
              <h4 class="pointer" @click="paymentsTogglePayments = !paymentsTogglePayments">
                <i
                  class="fa text-secondary"
                  aria-hidden="true"
                  :class="paymentsTogglePayments ? 'fa fa-caret-down' : 'fa fa-caret-right'"
                />
                <strong class="pl-1">
                  Payments
                </strong>
              </h4>
            </div>
            <div class="col-5 text-right">
              <strong>$ {{ paymentsSum ? paymentsSum : '0' }}</strong>
            </div>
          </div>
          <template v-if="paymentsTogglePayments">
            <template v-if="job.charges">
              <div
                class="row"
                v-for="(transaction, index) in job.charges.filter(el => el.payment_type_id === 1)"
                :key="`trans-prefix-1-${index}`"
              >
                <div class="col-7 billing-payment-name">
                  <h5 class="d-inline">{{ transaction.payment_method.name }}</h5>
                  <div
                    class="btn btn-link p-0 tippy-popup m-0"
                    @mouseover="$set(showTooltipPayments, index, true)"
                    @mouseout="$set(showTooltipPayments, index, false)"
                  >
                    <i class="fa fa-info-circle" />
                    <div
                      class="popover popover-transaction tippy-info-popover"
                      v-if="showTooltipPayments[index]"
                    >
                      <div>{{ transaction.date }}</div>
                      <div>
                        {{
                          transaction.payment_method_id === 4
                            ? '(**** ' + transaction.card.last4 + ')'
                            : ''
                        }}
                      </div>
                      <div>{{ transaction.note }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-5 text-right">$ {{ transaction.amount }}</div>
              </div>
            </template>
          </template>
          <div class="row mt-4 mb-2" v-if="refundsSum !== null">
            <div class="col-7">
              <h4 class="pointer" @click="paymentsToggleRefunds = !paymentsToggleRefunds">
                <i
                  class="fa text-secondary"
                  aria-hidden="true"
                  :class="paymentsToggleRefunds ? 'fa fa-caret-down' : 'fa fa-caret-right'"
                />
                <strong class="pl-1">
                  Refunds
                </strong>
              </h4>
            </div>
            <div class="col-5 text-right">
              <strong>$ {{ refundsSum !== null ? refundsSum : '0' }}</strong>
            </div>
          </div>
          <template v-if="paymentsToggleRefunds">
            <template v-if="job.charges">
              <div
                class="row"
                v-for="(transaction, index) in job.charges.filter(
                  el => el.payment_type_id === 2 || el.payment_type_id === 4,
                )"
                :key="`trans-prefix-2-${index}`"
              >
                <div class="col-7 billing-payment-name">
                  <h5 class="d-inline">{{ transaction.payment_method.name }}</h5>
                  <div
                    class="btn btn-link p-0 tippy-popup m-0"
                    @mouseover="$set(showTooltipRefunds, index, true)"
                    @mouseout="$set(showTooltipRefunds, index, false)"
                  >
                    <i class="fa fa-info-circle" />
                    <div
                      class="popover popover-transaction tippy-info-popover"
                      v-if="showTooltipRefunds[index]"
                    >
                      <div>{{ transaction.payment_type.name }}</div>
                      <div>{{ transaction.date }}</div>
                      <div>
                        {{
                          transaction.payment_method_id === 4
                            ? '(**** ' + transaction.card.last4 + ')'
                            : ''
                        }}
                      </div>
                      <div>{{ transaction.note }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-5 text-right">$ {{ transaction.amount }}</div>
              </div>
            </template>
          </template>
          <div class="row mt-2">
            <div class="col">
              <button
                type="button"
                class="add-button pointer pull-right"
                :class="{ disabled: !userHasAccessToCarrier || isFlatRate }"
                :disabled="!userHasAccessToCarrier || isFlatRate"
                v-if="$_can('job-expenses.store')"
                @click="toggleTransactionsModal"
              >
                Add Transaction
                <span class="ml-2 mr-0"><span class="mod-icon-add" /></span>
              </button>
            </div>
          </div>
          <div
            v-if="job.cash_collected === false && canShowCashCollect"
            class="flex align-items-center justify-content-center w-full mt-3"
          >
            <span class="btn-status btn-inprogress">
              Cash not collected
            </span>
          </div>
          <template v-if="job.total_hours">
            <div class="row mt-5 pt-3 border-top total-price">
              <div class="col-5">
                <h5>Total price</h5>
              </div>
              <div class="col-7 text-right pl-0" v-if="!isFlatRate">
                <p>$ {{ job.total_price }}</p>
                <p
                  class="cash-discount"
                  v-if="job.cash_discount_applied === 1 && job.remaining_cash_price === '-'"
                >
                  Paid fully in cash
                </p>
              </div>
              <div class="col-7 text-right pl-0" v-else>
                <p>$ {{ job.price }}</p>
              </div>
            </div>
            <div class="row total-fee disabled">
              <div class="col-7">
                <h5>Total fee</h5>
              </div>
              <div class="col-5 text-right">
                <p>$ {{ job.total_fee }}</p>
              </div>
            </div>
            <div class="row balance-due">
              <div class="col-6">
                <h5>Balance due</h5>
              </div>
              <div class="col-6 text-right text-danger">
                <p>$ {{ job.remaining_price }}</p>
              </div>
            </div>
            <template v-if="!isFlatRate">
              <div
                class="row balance-due"
                v-if="job.cash_discount_applied === 0 && job.remaining_cash_price !== '-'"
              >
                <div class="col">
                  <p class="cash-discount text-danger" v-if="job.company.cash_discount_value > 0">
                    with cash discount $ {{ job.remaining_cash_price }}
                  </p>
                </div>
              </div>
            </template>
          </template>
          <template v-if="job.status">
            <div class="row mt-4" v-if="$_can('jobs.status.update') && isActive">
              <div class="col-12">
                <div class="popover tippy-info-up" v-if="showTooltipCompleteJob">
                  Total time for the job must be entered
                </div>
              </div>
              <div
                class="col-12 text-right"
                @mouseover="!job.total_hours && (showTooltipCompleteJob = true)"
                @mouseout="!job.total_hours && (showTooltipCompleteJob = false)"
              >
                <button
                  type="button"
                  v-if="job.status.id === 40"
                  class="btn btn-primary w-100"
                  :disabled="!userHasAccessToCarrier"
                  @click="stopTimeTracking"
                >
                  Stop time tracking
                </button>
                <button
                  type="button"
                  v-if="showCompleteButton"
                  class="btn btn-primary w-100"
                  :class="{ disabled: !canComplete || !userHasAccessToCarrier }"
                  :disabled="!canComplete || !userHasAccessToCarrier"
                  @click="showAreYouSureModal = !showAreYouSureModal"
                >
                  Complete Job
                </button>
              </div>
            </div>
            <div class="row mt-4" v-if="job.status.name === 'Completed'">
              <div class="col-9 text-right">
                <button
                  v-if="job.ratings && job.ratings.length && job.source.name !== 'Mod24'"
                  type="button"
                  class="btn btn-success w-100"
                  disabled="disabled"
                >
                  Review received
                </button>
                <button
                  v-else-if="$_can('jobs.review.request') && !job.review_requested"
                  type="button"
                  class="btn btn-primary w-100"
                  :class="{ disabled: !userHasAccessToCarrier }"
                  :disabled="reviewRequested || !userHasAccessToCarrier"
                  @click="() => requestReview()"
                >
                  Request review
                </button>
                <button
                  v-else-if="$_can('jobs.resend.review.request') && job.review_requested"
                  type="button"
                  class="btn btn-primary w-100"
                  :class="{ disabled: !userHasAccessToCarrier }"
                  :disabled="reviewRequested || !userHasAccessToCarrier"
                  @click="() => requestReview(true)"
                >
                  Resend review request
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCustomerModal" @click.self="showCustomerModal = false">
        <side-modal-customer-info
          v-if="showCustomerModal"
          :data="job"
          @show-customer-modal-toggle="showCustomerModal = !showCustomerModal"
          :show-customer-modal="showCustomerModal"
          :job-id="job.id"
          @update="getJob"
          @cancel="showCustomerModal = false"
        />
      </div>
    </transition>

    <!-- Modal company reviews  -->
    <CustomerReviewModal
      v-if="companyReviewModal"
      :job="job"
      @getJob="getJob"
      @close="companyReviewModal = false"
    />

    <!-- Modal Assign Movers -->
    <modal
      v-if="showModalAssignMovers"
      @close="showModalAssignMovers = false"
      :loading-button="loadingButton"
      @ok="assignMovers"
    >
      <div slot="header">
        <h4>Assign movers</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <p v-if="!job.carrier_id" class="text-danger">Please assign carrier to view available movers</p>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Foreman</label>
              <simple-select
                v-model="assign.foreman"
                v-if="movers"
                :hide-deselect="true"
                :options="foremenOptions.filter(mover => !assign.movers.includes(mover))"
                label="first_name"
                :custom-label="customLabel"
                placeholder="Select"
                @input="errors.clear('mover_availability')"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="option__title">
                        {{ props.option.first_name }} {{ props.option.last_name }}
                        <span class="text-danger" v-if="props.option.unavailable">- unavailable</span>
                      </span>
                      <span
                        class="option__small m-0-auto pr-5 font-weight-bold position-absolute"
                        style="color: #ffab00; position: absolute; right: 30%"
                        v-if="props.option.ref_id && props.option.job_id"
                        @mousedown.left.stop="navigateToJob(props.option.job_id)"
                      >
                        Assigned to {{ props.option.ref_id }}
                      </span>
                    </div>
                  </div>
                </template>
              </simple-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="select-wrap">
              <label>Movers</label>
              <multiselect
                v-model="assign.movers"
                v-if="movers"
                :options="movers.filter(mover => mover.id !== assign.foreman)"
                :multiple="true"
                class=""
                :clear-on-select="false"
                :hide-selected="true"
                :preserve-search="false"
                :select-label="customSelectLabel"
                :custom-label="customLabel"
                track-by="id"
                @input="errors.clear('mover_availability')"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag">
                    <span>{{ props.option.first_name && props.option.first_name }}</span>
                    <span>{{ props.option.last_name && props.option.last_name }}</span>
                    <span class="text-danger" v-if="props.option.unavailable">- unavailable</span>
                    <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="option__title">
                        {{ props.option.first_name }} {{ props.option.last_name }}
                        <span class="text-danger" v-if="props.option.unavailable">- unavailable</span>
                      </span>
                      <span
                        class="option__small m-0-auto pr-5 font-weight-bold position-absolute"
                        style="color: #ffab00; position: absolute; right: 30%"
                        v-if="props.option.ref_id && props.option.job_id"
                        @click.left.exact.stop="navigateToJob(props.option.job_id)"
                      >
                        Assigned to {{ props.option.ref_id }}
                      </span>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <error-field :errors="errors" field="mover_availability" />
      </div>
    </modal>

    <!-- Modal Assign Trucks -->
    <modal
      v-if="showModalAssignTrucks"
      @close="showModalAssignTrucks = false"
      :loading-button="loadingButton"
      @ok="assignTrucks"
    >
      <div slot="header">
        <h4>Assign trucks</h4>
      </div>
      <div slot="body">
        <p v-if="!job.carrier_id" class="text-danger">Please assign carrier to view available trucks</p>
        <div class="select-wrap">
          <label>Trucks</label>
          <multiselect
            v-model="assign.trucks"
            :options="trucks"
            :multiple="true"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="false"
            label="name"
            track-by="id"
            :select-label="customSelectLabel"
            :taggable="true"
            @input="errors.clear('truck_availability')"
          >
            <template slot="tag" slot-scope="props">
              <span class="multiselect__tag">
                <span>{{ props.option.name }} </span>
                <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
              </span>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <div class="d-flex align-items-center">
                  <span class="option__title">
                    {{ props.option.name }}
                    <span class="text-danger" v-if="props.option.unavailable">- unavailable</span>
                  </span>
                  <span
                    class="option__small m-0-auto pr-5 font-weight-bold"
                    style="color: #ffab00"
                    v-if="props.option.ref_id && props.option.job_id"
                    @click.left.exact.stop="navigateToJob(props.option.job_id)"
                  >
                    Assigned to {{ props.option.ref_id }}
                  </span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <error-field :errors="errors" field="truck_availability" />
      </div>
    </modal>

    <!-- reassignCarrier modal -->
    <modal
      v-if="showCarrierReassignModal"
      @close="
        showCarrierReassignModal = false;
        job.carrier_id = job.carrier ? job.carrier.id : null;
      "
      :size="'modal-large'"
      :close-strict="true"
    >
      <div slot="header">
        <h4>Assign carrier</h4>
      </div>
      <div slot="body">
        <p v-if="job.carrier">
          Changing assigned carrier will remove all movers and trucks from this move.
        </p>
        <div class="d-flex flex-column">
          <div class="form-row">
            <div class="col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3" />
            <div class="row col-md-8">
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <small class="text-secondary">Movers AM</small>
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <small class="text-secondary">Movers PM</small>
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <small class="text-secondary">Trucks AM</small>
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <small class="text-secondary">Trucks PM</small>
              </div>
            </div>
          </div>
          <div
            v-for="carrier in carriersForAssign"
            @click="setCarrier(carrier.id)"
            :key="carrier.name"
            class="form-row"
            :class="{ 'radio-border-blue': job.carrier_id === carrier.id }"
          >
            <div class="col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3">
              <label class="pointer text-left w-100 h-100 d-flex align-items-center">
                <input
                  :checked="job.carrier_id === carrier.id"
                  type="radio"
                  :id="'carrier-' + carrier.id"
                />
                <span class="btn-radio" />
                <label
                  :for="'carrier-' + carrier.id"
                  class="btn-radio-label"
                  v-text="carrier.name"
                />
              </label>
            </div>
            <div class="row col-md-8">
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <span
                  class="btn-status btn-amount"
                  :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'am')]"
                  v-text="carrier.available_movers_am + ' / ' + carrier.total_movers"
                />
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <span
                  class="btn-status btn-amount"
                  :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'pm')]"
                  v-text="carrier.available_movers_pm + ' / ' + carrier.total_movers"
                />
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <span
                  class="btn-status btn-amount"
                  :class="[giveStyleAssignCarrierAvailability(carrier, 'trucks', 'am')]"
                  v-text="carrier.available_trucks_am + ' / ' + carrier.total_trucks"
                />
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-center">
                <span
                  class="btn-status btn-amount"
                  :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'pm')]"
                  v-text="carrier.available_trucks_pm + ' / ' + carrier.total_trucks"
                />
              </div>
            </div>
          </div>
        </div>
        <error-field :errors="errors" field="availability" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-center">
            <button
              class="btn btn-secondary"
              type="button"
              @click="
                showCarrierReassignModal = false;
                job.carrier_id = job.carrier ? job.carrier.id : null;
              "
            >
              Discard
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="reassignCarrier"
              v-text="job.carrier ? 'Reassign' : 'Assign'"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- reassignUser modal -->
    <modal
      v-if="showUserReassignModal"
      @close="showUserReassignModal = false"
      :size="'modal-large'"
      :close-strict="true"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <div>
              <h4>Select user to assign job to</h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="select-wrap">
          <label>Select User</label>
          <simple-select v-model="assigneeId" :options="assignees" @change="clearError($event)" />
        </div>
        <error-field :errors="errors" field="cluster_user_id" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12">
            <button type="button" class="btn btn-primary pull-right" @click="reassignUser">
              Reassign
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Job Completion New Transaction -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="newTransaction">
        <transactions-modal
          class="sidebar-right"
          @cancel="toggleTransactionsModal"
          @update="sendMovingContractEmail"
          :job="job"
        />
      </div>
    </transition>

    <!-- Modal cancel job -->
    <modal v-if="showModalCancelJob" @close="showModalCancelJob = false">
      <div slot="header">
        <h4>Cancellation note</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap h-auto">
              <label>Note</label>
              <textarea
                rows="5"
                class="select-wrap-textarea form-control"
                v-model="note"
                @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="note" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-secondary" type="button" @click="showModalCancelJob = false">
              Discard
            </button>
            <button class="btn btn-primary" @click="changeStatus(job.id, 30)">Proceed</button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal reject job -->
    <modal v-if="showModalRejectJob" @close="showModalRejectJob = false">
      <div slot="header">
        <h4 class="pb-2">Rejection note</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <p class="mb-1">
              Move <b>{{ job.ref_id }}</b> was marked as <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
              <span v-if="job.is_small === 1">deselect it for an all day job.</span><span v-else>select it for a small job.</span>
            </p>
            <div class="customer-check-field pb-3">
              <span class="customer-checkmark" />
              Small job
              <input
                type="checkbox"
                :value="job.is_small"
                :checked="job.is_small === 1"
                @change="changeSmallJob"
              />
            </div>
            <div class="select-wrap h-auto mt-3">
              <label>Note</label>
              <textarea
                class="select-wrap-textarea form-control"
                rows="5"
                v-model="note"
                @keydown="clearError($event)"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-secondary" type="button" @click="showModalRejectJob = false">
              Discard
            </button>
            <button class="btn btn-primary" @click="updateJobStatusChange(job.id, 31)">
              Proceed
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal AcceptJob job -->
    <modal v-if="showModalAcceptJob" @close="showModalAcceptJob = false">
      <div slot="header">
        <h4 class="pb-2">Accept job</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div>
              <p class="mb-1">
                Move <b>{{ job.ref_id }}</b> was marked as <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
                <span v-if="job.is_small === 1">deselect if it is a all day job.</span><span v-else>select it if its a small job.</span>
              </p>
              <div class="customer-check-field">
                <span class="customer-checkmark" />
                Small job
                <input
                  type="checkbox"
                  :value="job.is_small"
                  :checked="job.is_small === 1"
                  @change="changeSmallJob"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-secondary" type="button" @click="showModalAcceptJob = false">
              Discard
            </button>
            <button class="btn btn-primary" @click="updateJobStatusChange(job.id, 3)">
              Accept
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!--  Small job modal  -->
    <modal v-if="showModalIsSmallJob" @close="showModalIsSmallJob = false">
      <div slot="header">
        <h4 class="pb-2">Job size</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div>
              <p class="mb-1">
                Move <b>{{ job.ref_id }}</b> was marked as <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
                <span v-if="job.is_small === 1">deselect if it is a all day job.</span><span v-else>select it if its a small job.</span>
              </p>
              <div class="customer-check-field">
                <span class="customer-checkmark" />
                Small job
                <input
                  type="checkbox"
                  :value="job.is_small"
                  :checked="job.is_small === 1"
                  @change="changeSmallJob"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-primary" type="button" @click="save">Save</button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal send automatic messages to movers -->
    <modal v-if="sendAutomaticMessages === true" @close="sendAutomaticMessages = false">
      <div slot="header">
        <h4>Send Automatic Messages</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col-12">
            <p>
              You are about to send automatically generated messages to movers.<br />
              Are you sure you want to continue?
            </p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-6 pr-1">
            <button
              type="button"
              class="btn btn-secondary w-100"
              @click="sendAutomaticMessages = false"
            >
              Cancel
            </button>
          </div>
          <div class="col-6 pl-1">
            <button
              type="button"
              class="btn btn-primary w-100 ld-ext-right"
              :class="{ running: loadingButton }"
              :disabled="buttonDisabled || loadingButton"
              @click="sendMessages"
            >
              Continue
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!--- CLAIM MODAl -->
    <CreateClaimModal v-if="newClaim" @closeModal="newClaim = false" :job="job" @update="getJob" />

    <!-- ARE YOU SURE MODAL -->
    <AreYouSure
      v-if="showAreYouSureModal"
      @prevStep="prevStep"
      @getJob="getJob"
      @close="showAreYouSureModal = false"
      @errors="recordErrors"
    />

    <!-- ARE YOU SURE REVERT TO ACCEPTED MODAL -->
    <AreYouSureRevertToAccepted
      v-if="showAreYouSureRevertModal"
      :loading="areYouSureLoading"
      @revertToAccepted="revertToAccepted"
      @close="showAreYouSureRevertModal = false"
    />

    <AreYouSureRevertToTotalTime
      v-if="showAreYouSureRevertTotalTimeModal"
      :loading="areYouSureTotalTimeLoading"
      @revertToTotalTime="revertToTotalTime"
      @close="showAreYouSureRevertTotalTimeModal = false"
    />

    <!-- SEND EPAY LINK MODAL -->
    <SendEpayLink v-if="showSendEpayLinkModal" :job="job" @close="showSendEpayLinkModal = false" />

    <modal v-if="showClearCashDiscountModal" @close="showClearCashDiscountModal = false">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">
          Remove Cash discount
        </h4>
      </div>
      <div slot="body">
        <p class="text-center">Are you sure to remove Cash Discount?</p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click.prevent="removeCashDiscount()">Yes</button>
        <button class="btn btn-danger" @click.prevent="showClearCashDiscountModal = false">
          No
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import moment from 'moment/moment';
import Errors from '../../classes/Errors';
import 'flatpickr/dist/flatpickr.css';
import Modal from '../Modal';
import SideModalCustomerInfo from '../SideModalCustomerInfo';
import PhoneMask from '../../classes/PhoneMask';
import ContentLoader from '../ContentLoader';
import CreateClaimModal from '../claims/Modals/CreateClaim';
import TransactionsModal from '../transactions/TransactionsModal';
import JobStatus from './JobStatus';
import JobMoveInfo from './JobMoveInfo';
import JobClaimBanner from './JobClaimBanner';
import JobRating from './JobRating';
import JobInfo from './JobInfo';
import JobCustomerInfo from './JobCustomerInfo';
import JobRates from './JobRates';
import JobsTabs from './JobsTabs';
import JobsTabsContent from './JobsTabsContent';
import JobDetails from './JobDetails';
import CustomerReviewModal from './modals/CustomerReviewModal';
import AreYouSure from './modals/AreYouSure';
import AreYouSureRevertToAccepted from './modals/AreYouSureRevertToAccepted';
import TagColor from '../settings/Tags/TagColor';
import InputTime from '../InputTime';
import AreYouSureRevertToTotalTime from './modals/AreYouSureRevertToTotalTime';
import SendEpayLink from './modals/SendEpayLink';
import HeavyItemsDisclaimer from '../HeavyItemsDisclaimer';

export default {
  name: 'JobsEdit',
  components: {
    HeavyItemsDisclaimer,
    AreYouSure,
    AreYouSureRevertToAccepted,
    AreYouSureRevertToTotalTime,
    ContentLoader,
    CreateClaimModal,
    CustomerReviewModal,
    InputTime,
    JobClaimBanner,
    JobCustomerInfo,
    JobDetails,
    JobInfo,
    JobMoveInfo,
    JobRates,
    JobRating,
    JobStatus,
    JobsTabs,
    JobsTabsContent,
    Modal,
    SendEpayLink,
    SideModalCustomerInfo,
    TagColor,
    TransactionsModal,
  },
  data: () => ({
    addingNewAdditionalExpense: false,
    addingNewDiscountExpense: false,
    addingNewMoverTips: false,
    additionalExpensesToggleAddition: false,
    additionalExpensesToggleDiscount: false,
    address: null,
    addresses: [],
    areYouSureLoading: false,
    areYouSureTotalTimeLoading: false,
    arrival_windows: [],
    assign: {
      trucks: [],
      movers: [],
      foreman: null,
    },
    assigneeId: null,
    assignees: [],
    buttonDisabled: false,
    cancellationNote: null,
    carriersForAssign: [],
    changes: [],
    changesLoading: false,
    companyReviewModal: false,
    config: {
      dateFormat: 'm/d/Y',
      wrap: true,
      minDate: 'today',
      disableMobile: true,
    },
    configTimepicker: null,
    customerModalStep: 1,
    customerNote: '',
    customers: [],
    ddTime: '',
    ddTimeConfig: null,
    deletedLocations: false,
    discounts: [],
    discountTypes: [
      {
        id: 1,
        name: 'Discount',
      },
      {
        id: 2,
        name: 'Carrier Covered',
      },
      {
        id: 3,
        name: 'Office Covered',
      },
    ],
    editNote: false,
    editableExpenseAddition: [],
    editableExpenseDiscount: [],
    editableFields: false,
    editedField: false,
    emailConfirmationModalShown: false,
    errors: new Errors(),
    expenses: [],
    geocodeTimeout: null,
    job: {
      addresses: [
        {
          full_address: '',
          street_name: '',
          state_id: 0,
          city: '',
          postal_code: '',
          apartment: '',
          type_id: 1,
        },
      ],
      assigned_movers: [],
      carrier_id: null,
      carrier: null,
      customer: [
        {
          contacts: [],
        },
      ],
      company: {},
      arrival_window_id: null,
      cluster_user: [],
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      move_date: '',
      move_date_new: '',
      move_size_id: null,
      movers: [],
      note: '',
      notes: [],
      route_id: '',
      source_id: null,
      status_id: '',
      trucks: '',
      review_requested: false,
      estimated_hours: null,
      customer_id: null,
      foreman_id: null,
    },
    jobCompletionStep1: true,
    jobLoading: false,
    jobTabStep: 1,
    jobTime: '',
    jobTimeConfig: null,
    jobTotalHours: '',
    leadSource: '',
    loadingBookButton: false,
    loadingButton: false,
    loadingButtonMovers: [],
    loadingDiscardButton: false,
    map: {},
    move_sizes: [],
    movers: [],
    newClaim: false,
    newDiscount: {
      name: '',
      type_id: 0,
      amount: '',
      unit: 1,
    },
    newExpense: {
      name: '',
      type_id: 0,
      amount: '',
    },
    newTransaction: false,
    note: '',
    numberOfMovers: [],
    paymentsSum: null,
    paymentsTogglePayments: false,
    paymentsToggleRefunds: false,
    phoneMask: new PhoneMask(),
    pricesAndPaymentsStep: 1,
    refundsSum: null,
    reviewRequested: false,
    rightSidebarTab: 'priceBreakdown',
    route: [],
    selectedMoverId: null,
    sendAutomaticMessages: false,
    showAreYouSureModal: false,
    showAreYouSureRevertModal: false,
    showAreYouSureRevertTotalTimeModal: false,
    showCarrierReassignModal: false,
    showClearCashDiscountModal: false,
    showCustomerModal: false,
    showDropdown: [
      {
        0: false,
      },
    ],
    showDropdownStatus: false,
    showEmailConfirmationModal: false,
    showModalAcceptJob: false,
    showModalAddExpense: false,
    showModalAssignMovers: false,
    showModalAssignTrucks: false,
    showModalCancelJob: false,
    showModalIsSmallJob: false,
    showModalJobCompletion: false,
    showModalNewTransaction: false,
    showModalRejectJob: false,
    showSendEpayLinkModal: false,
    showTooltipCompleteJob: false,
    showTooltipP: false,
    showTooltipPayments: [],
    showTooltipRefunds: [],
    showTooltipTransactions: [],
    showUserReassignModal: false,
    sources: [],
    token: process.env.MAPBOX_TOKEN,
    tipType: [
      {
        id: 1,
        name: 'Addition',
      },
      {
        id: 2,
        name: 'Cash',
      },
      {
        id: 3,
        name: 'Credit card',
      },
    ],
    trucks: [],
  }),
  computed: {
    ...mapState({
      discountUnitTypes: state => state.values.discountUnitTypes,
      jobStatuses: state => state.values.jobStatuses,
      plans: state => state.plans.plans,
      states: state => state.values.states,
      transactions: state => state.transactions.transactions.data,
      user: state => state.auth.dispatchUser,
    }),
    canShowCashCollect() {
      return (
        this.job.status_id === 16 ||
        this.job.status_id === 41 ||
        this.job.status_id === 42 ||
        this.job.status_id === 47
      );
    },
    canAddTips() {
      if (this.job.status.name === 'Completed' && this.$_can('jobs.completed.update')) {
        return true;
      }
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    canAdjustTimeTracking() {
      if (this.job.status.name === 'Completed' && this.$_can('jobs.completed.update')) {
        return false;
      }
      return this.job.status.name === 'Canceled';
    },
    canComplete() {
      return (
        !(parseFloat(this.job.remaining_price.replace(/,/g, '')) > 0) &&
        moment.duration(this.job.total_hours).asHours() > 0
      );
    },
    canEditJob() {
      if (this.job.status.name === 'Completed' && this.$_can('jobs.completed.update')) {
        return true;
      }
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    customSelectLabel() {
      return `Select`;
    },
    hasClaim() {
      return this.job.claim !== null;
    },
    isActive() {
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    isFlatRate() {
      return this.job.is_flat_rate === 1;
    },
    isSmallJob() {
      if (this.job.is_small === 1) {
        return 'Small job';
      }
      return 'All day job';
    },
    foremenOptions() {
      return this.movers.filter(mover => mover.foreman);
    },
    jobIsEditable() {
      return this.job.status && this.job.status.name !== 'Canceled';
    },
    jobStatus() {
      if (this.job.status_id === 40 || this.job.status_id === 41) {
        return true;
      }
      return this.job.status_id === 42 || this.job.status_id === 16;
    },
    showCompleteButton() {
      return (
        this.job.status.id === 41 ||
        this.job.status.id === 42 ||
        this.job.status.id === 43 ||
        this.job.status.id === 44 ||
        this.job.status.id === 45 ||
        this.job.status.id === 46 ||
        this.job.status.id === 47
      );
    },
    showMovingContractButton() {
      return this.job.status.name === 'Completed' && this.job.send_contract_at !== undefined;
    },
    userHasAccessToCarrier() {
      if (this.user.roles.some(role => role.id === 1)) {
        return true;
      }
      if (!this.job.carrier) {
        return true;
      }
      return this.user.carriers.some(carrier => carrier.id === this.job.carrier_id);
    },
  },
  watch: {
    job() {
      this.getArrivalWindows();
      this.getSources();
      this.getNumberOfMovers(this.job.company_id);
      this.getMoveSizes();
      this.customerNote = this.job.customer_note ? this.job.customer_note.note : '';
      const payments = this.job.charges && this.job.charges.filter(el => el.payment_type_id === 1);
      if (payments.length) {
        if (payments.map(el => parseFloat(el.amount.replace(/,/g, ''))).length > 0) {
          this.paymentsSum = payments
            .map(el => parseFloat(el.amount.replace(/,/g, '')))
            .reduce((carrier, current) => carrier + current)
            .toFixed(2);
        }
      }
      const refunds =
        this.job.charges &&
        this.job.charges.filter(el => el.payment_type_id === 2 || el.payment_type_id === 4);
      if (refunds.length) {
        if (refunds.map(el => parseFloat(el.amount.replace(/,/g, ''))).length > 0) {
          this.refundsSum = refunds
            .map(el => parseFloat(el.amount.replace(/,/g, '')))
            .reduce((carrier, current) => carrier + current)
            .toFixed(2);
        }
      }
      if (this.job.status_id !== 16) {
        this.getChanges();
      }
      if (this.job.status_id === 16 && this.job.send_contract_at) {
        const self = this;
        setTimeout(
          () => {
            self.getJob();
          },
          moment(this.job.send_contract_at, 'YYYY-MM-DDThh:mm:ss.ssssssZ')
            .add('10', 's')
            .diff(moment()),
        );
      } else {
        this.emailConfirmationModalShown = false;
        this.showEmailConfirmationModal = false;
      }
    },
    $route() {
      this.getJob();
      this.getExpenses();
      this.getDiscounts();
      if (this.$route.query.q) {
        axios.defaults.headers.q = encodeURIComponent(this.$route.query.q);
      }
      this.getJobs();
      this.getCarriers();
    },
  },
  created() {
    this.getExpenses();
    this.getDiscounts();
    if (this.$route.query.q) {
      axios.defaults.headers.q = encodeURIComponent(this.$route.query.q);
    }
    this.getJobs();
    this.getCarriers();
  },
  methods: {
    addAdditionalContact() {
      this.job.customer.contacts.push({
        email: '',
        phone: '',
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
      });
    },
    addingNewExpense(type) {
      if (type === 'additional') {
        this.addingNewAdditionalExpense = true;
        this.addingNewDiscountExpense = false;
        this.addingNewMoverTips = false;
      } else if (type === 'tips') {
        this.addingNewMoverTips = true;
        this.addingNewAdditionalExpense = false;
        this.addingNewDiscountExpense = false;
      } else {
        this.addingNewAdditionalExpense = false;
        this.addingNewMoverTips = false;
        this.addingNewDiscountExpense = true;
      }
    },
    assignMovers() {
      const movers = this.assign.movers.map(mover => {
        return { id: mover.id, foreman: false, ref_id: mover.ref_id ? mover.ref_id : null };
      });
      if (this.assign.foreman) {
        const foremanTmp = this.movers.find(mover => mover.id === this.assign.foreman);
        foremanTmp.foreman = true;
        movers.push(foremanTmp);
      }
      this.loadingButton = true;
      axios
        .put(`/jobs/${this.$route.params.id}/movers`, { movers })
        .then(() => {
          this.showModalAssignMovers = false;
          this.assign = {};
          this.getJob();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.buttonDisabled = false;
          this.loadingButton = false;
        });
    },
    assignTrucks() {
      const trucks = this.assign.trucks.map(truck => {
        return { id: truck.id, ref_id: truck.ref_id ? truck.ref_id : null };
      });
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .put(`/jobs/${this.$route.params.id}/trucks`, { trucks })
        .then(() => {
          this.showModalAssignTrucks = false;
          this.assign = {};
          this.getJob();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    changeSmallJob() {
      this.job.is_small = this.job.is_small === 0 ? 1 : 0;
    },
    changeStatus(id, statusId) {
      if (statusId) {
        this.$set(this.job, 'status', this.jobStatuses.find(s => s.id === statusId));
        this.showDropdownStatus = false;
        this.showModalRejectJob = false;
        this.showModalAcceptJob = false;
        axios
          .put(`jobs/${id}/status`, { status_id: statusId, note: this.note })
          .then(() => {
            toastr.success('Successfully updated status');
            this.showModalCancelJob = false;
            this.getJob();
            this.note = '';
          })
          .catch(err => {
            this.getJob();
            this.errors.record(err.response.data.error);
          });
      }
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    customLabel(option) {
      return (
        `${option.first_name === undefined ? '' : option.first_name}` +
        ` ${option.last_name === undefined ? '' : option.last_name}`
      );
    },
    discardJob() {
      this.loadingDiscardButton = true;
      this.buttonDisabled = true;
      this.getJob();
    },
    editCustomer(id) {
      axios
        .put(`customers/${id}`, { ...this.job.customer })
        .then(() => {
          toastr.success('Successfully edited customer');
          this.customerModalStep = 1;
          this.showCustomerModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    editExpenseAddition(index) {
      this.$set(this.editableExpenseAddition, index, !this.editableExpenseAddition[index]);
      this.getExpenses();
    },
    editExpenseDiscount(index) {
      this.$set(this.editableExpenseDiscount, index, !this.editableExpenseDiscount[index]);
      this.getDiscounts();
    },
    getArrivalWindows() {
      axios
        .get(`companies/${this.job.company.id}/arrival-windows?ref_id=${this.job.ref_id}`)
        .then(result => {
          result.data.data.forEach(arrivalWindow => {
            arrivalWindow.label = `${arrivalWindow.from}-${arrivalWindow.to}`;
          });
          this.arrival_windows = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getCarriers() {
      axios
        .get(`carriers/job/${this.$route.params.id}`)
        .then(res => {
          this.carriersForAssign = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getContacts(id) {
      axios
        .get(`/customers/${id}/contacts`)
        .then(res => {
          this.contacts = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getChanges() {
      axios
        .get(`/jobs/${this.job.id}/logs/changes`)
        .then(res => {
          this.changes = res.data.data;
          this.changesLoading = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getDiscounts() {
      axios
        .get(`/jobs/${this.$route.params.id}/job-discounts`)
        .then(res => {
          this.discounts = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getExpenses() {
      axios
        .get(`/jobs/${this.$route.params.id}/job-expenses`)
        .then(res => {
          this.expenses = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getJob(callback = null) {
      if (this.$route.params.id !== 'undefined') {
        this.jobLoading = true;
        axios
          .get(`jobs/${this.$route.params.id}`)
          .then(res => {
            this.job = {
              ...res.data.data,
              double_drive_time: res.data.data.double_drive_time
                ? res.data.data.double_drive_time
                : '0:00',
              job_time: res.data.data.job_time ? res.data.data.job_time : '0:00',
            };
            this.customerNote = this.job.customer_note ? this.job.customer_note.note : '';
            const primaryCard = this.job.customer.customer_cards.find(c => c.is_default === 1);
            if (this.transaction) {
              this.transaction.card_id = primaryCard ? primaryCard.id : null;
            }
            this.$set(this.job, 'move_date_new', res.data.data.move_date);
            this.cancellationNote = res.data.data.status_logs.find(
              el => el.status.name === 'Canceled',
            );
            this.deletedLocations = false;
            this.areYouSureLoading = false;
            this.getContacts(res.data.data.customer.id);
            this.getExpenses();
            this.getDiscounts();
            this.ddTime = this.job.double_drive_time;
            this.jobTime = this.job.job_time;
            this.jobTotalHours = this.job.total_hours;
          })
          .then(() => {
            if (this.job.carrier_id) {
              this.getMovers();
              this.getTrucks();
            }
            if (callback) {
              callback();
            }
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.buttonDisabled = false;
            this.loadingButton = false;
            this.loadingDiscardButton = false;
            this.editableFields = false;
            this.editedField = false;
            this.showAreYouSureModal = false;
            this.jobLoading = false;
          });
      }
    },
    getJobs() {
      axios
        .get(`jobs/${this.$route.params.id}`)
        .then(result => {
          this.job = result.data.data;
          this.cancellationNote = result.data.data.status_logs.find(
            el => el.status.name === 'Canceled',
          );
          document.title = `${result.data.data.ref_id} - ${
            result.data.data.customer ? result.data.data.customer.first_name : ''
          }`;
          if (result.data.data.customer && result.data.data.customer.last_name) {
            document.title += ` ${result.data.data.customer.last_name}`;
          }
          this.ddTime = this.job.double_drive_time;
          this.jobTime = this.job.job_time;
          this.jobTotalHours = this.job.total_hours;
        })
        .then(() => {
          this.$nextTick(() => {
            const vm = this;
            this.configTimepicker = {
              minuteInterval: this.job.company.minute_increment,
            };
            this.jobTimeConfig = {
              enableTime: true,
              noCalendar: true,
              dateFormat: 'H:i',
              time_24hr: true,
              defaultDate: '00:00',
              minuteIncrement: this.job.company.minute_increment,
              onChange(dstr, dobjs, fp) {
                if (vm.job.company.minute_increment !== 1) {
                  const d = fp.latestSelectedDateObj;
                  const mins = d.getMinutes();

                  if (mins % vm.job.company.minute_increment)
                    d.setMinutes(
                      vm.job.company.minute_increment *
                        Math.round(d.getMinutes() / vm.job.company.minute_increment),
                    );
                  fp.setDate(d, false);
                  vm.job.job_time = `${d.getHours()}:${d.getMinutes()}`;
                }
              },
            };
            this.ddTimeConfig = {
              enableTime: true,
              noCalendar: true,
              dateFormat: 'H:i',
              time_24hr: true,
              defaultDate: '00:00',
              minuteIncrement: this.job.company.minute_increment,
              onChange(dstr, dobjs, fp) {
                if (vm.job.company.minute_increment !== 1) {
                  const d = fp.latestSelectedDateObj;
                  const mins = d.getMinutes();

                  if (mins % vm.job.company.minute_increment)
                    d.setMinutes(
                      vm.job.company.minute_increment *
                        Math.round(d.getMinutes() / vm.job.company.minute_increment),
                    );
                  fp.setDate(d, false);
                  vm.job.double_drive_time = `${d.getHours()}:${d.getMinutes()}`;
                }
              },
            };
            window.$('input').attr('autocomplete', 'no');
            if (this.job.source.name === 'Mod24' && this.job.lead_id) {
              axios.get(`leads/${this.job.lead_id}/source`).then(res => {
                this.leadSource = res.data.data;
              });
            }
          });
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    getMovers() {
      axios
        .get(
          `carriers/${this.job.carrier_id}/mover/availability?move_date=${
            this.job.move_date
          }&job_id=${this.job.id}`,
        )
        .then(res => {
          this.movers = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getMoveSizes() {
      axios
        .get(`companies/${this.job.company_id}/move-sizes`)
        .then(result => {
          this.move_sizes = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getNumberOfMovers(id) {
      axios
        .get(`/companies/${id}/values/movers`)
        .then(res => {
          this.numberOfMovers = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getSources() {
      axios
        .get(`values/sources?company_id=${this.job.company_id}`) // TODO: set sources to vuex if needed
        .then(res => {
          this.sources = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getTrucks() {
      axios
        .get(
          `carriers/${this.job.carrier_id}/truck/availability?move_date=${
            this.job.move_date
          }&job_id=${this.job.id}`,
        )
        .then(res => {
          this.trucks = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    giveStyleAssignCarrierAvailability(carrier, type, dayPeriod) {
      let availability = 0;
      if (type === 'movers') {
        availability =
          dayPeriod.toLowerCase() === 'am'
            ? carrier.available_movers_am
            : carrier.available_movers_pm;
      } else if (type === 'trucks') {
        availability =
          dayPeriod.toLowerCase() === 'am'
            ? carrier.available_trucks_am
            : carrier.available_trucks_pm;
      }

      if (availability === 0) {
        return 'orange-yellow-border-text red-border-text';
      }
      if (availability !== parseInt(carrier[`total_${type}`], 0)) {
        return 'orange-yellow-border-text';
      }
      return 'turquoise-border-text';
    },
    hideCustomerModal() {
      this.showCustomerModal = false;
      this.errors.clear();
      this.customerModalStep = 1;
      this.getJob();
    },
    movingContractSent(immediate = true) {
      this.showEmailConfirmationModal = false;
      if (immediate) {
        this.getJob();
      }
    },
    navigateToJob(id) {
      const routeData = this.$router.resolve({
        path: `/jobs/edit/${id}`,
      });
      window.open(routeData.href, '_blank');
    },
    openAssignedMoversModal() {
      this.showModalAssignMovers = true;
      if (this.job.carrier_id) {
        this.getMovers();
        this.assign = {
          movers: this.job.assigned_movers,
          foreman: this.job.foreman_id,
        };
        this.$nextTick(() => this.selectedForeman());
      }
    },
    openAssignedTrucksModal() {
      this.showModalAssignTrucks = true;
      if (this.job.carrier_id) {
        this.getTrucks();
        this.assign = {
          trucks: this.job.assigned_trucks,
        };
      }
    },
    prevStep() {
      this.errors.clear();
      this.jobCompletionStep1 = true;
    },
    recordErrors(value) {
      this.errors.record(value);
    },
    revertToAccepted() {
      this.areYouSureLoading = true;
      this.$set(this.job, 'total_hours', '00:00');
      this.$set(this.job, 'status_id', 3);
      axios
        .put(`jobs/${this.$route.params.id}`, {
          double_drive_time: '00:00',
          job_time: '00:00',
          status_id: 3,
        })
        .then(() => {
          axios.delete(`/locations/tracking/${this.job.id}`).then(() => {
            toastr.success('Successfully updated job');
            this.deletedLocations = true;
          });
          this.getJob();
        })
        .catch(err => {
          if (err.response.data.error.addresses) {
            toastr.error(err.response.data.error.addresses[0]);
          }
          if (err.response.data.error.booking) {
            toastr.error(err.response.data.error.booking[0]);
          }
          this.errors.record(err.response.data.error);
        });
    },
    revertToTotalTime() {
      this.areYouSureTotalTimeLoading = true;
      this.$set(this.job, 'status', this.jobStatuses.find(s => s.id === 41));
      axios
        .put(`jobs/${this.job.id}/status`, { status_id: 41, note: '' })
        .then(() => {
          toastr.success('Successfully reverted to total time');
          this.showAreYouSureRevertTotalTimeModal = false;
          this.getJob();
          this.note = '';
        })
        .catch(err => {
          this.getJob();
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.areYouSureTotalTimeLoading = false;
        });
    },
    save(time = false) {
      this.showModalIsSmallJob = false;
      if (this.isActive || this.$_can('jobs.completed.update')) {
        this.buttonDisabled = true;
        this.loadingButton = true;
        if (Number.isNaN(this.job.price_per_hour)) {
          this.$set(
            this.job,
            'price_per_hour',
            parseFloat(this.job.price_per_hour.replace(/,/g, '')),
          );
        }
        const job = { ...this.job };
        if (!time) {
          this.$delete(job, 'double_drive_time');
          this.$delete(job, 'job_time');
        } else {
          this.$delete(job, 'carrier_id');
        }
        axios
          .put(`jobs/${this.$route.params.id}`, job)
          .then(() => {
            toastr.success('Successfully updated job');
            this.getJob();
          })
          .catch(err => {
            if (err.response.data.error.addresses) {
              toastr.error(err.response.data.error.addresses[0]);
            }
            if (err.response.data.error.booking) {
              toastr.error(err.response.data.error.booking[0]);
            }
            if (err.response.data.error.availability) {
              toastr.error(err.response.data.error.availability[0]);
            }
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
    saveCustomerNote(callback) {
      this.getJob(callback);
    },
    saveDdTime(doubleDriveTime) {
      if (this.isActive || this.$_can('jobs.completed.update')) {
        this.buttonDisabled = true;
        this.loadingButton = true;
        setTimeout(() => {
          axios
            .patch(`jobs/${this.$route.params.id}/double-drive`, {
              double_drive_time: doubleDriveTime,
            })
            .then(() => {
              toastr.success('Successfully updated job');
              this.sendMovingContractEmail();
            })
            .catch(err => {
              if (err.response.data.error.addresses) {
                toastr.error(err.response.data.error.addresses[0]);
              }
              if (err.response.data.error.booking) {
                toastr.error(err.response.data.error.booking[0]);
              }
              this.errors.record(err.response.data.error);
            })
            .finally(() => {
              this.loadingButton = false;
              this.buttonDisabled = false;
            });
        }, 800);
      }
    },
    saveDiscount() {
      this.newDiscount.job_id = this.$route.params.id;
      this.newDiscount.type_id = null;
      if (this.$_can('jobs.discount.add.general.covered')) {
        this.newDiscount.type_id = 1;
      } else if (this.$_can('jobs.discount.add.carrier.covered')) {
        this.newDiscount.type_id = 2;
      } else if (this.$_can('jobs.discount.add.office.covered')) {
        this.newDiscount.type_id = 3;
      }
      axios
        .post('job-discounts', { ...this.newDiscount })
        .then(res => {
          this.$set(this.discounts, this.discounts.length, res.data.data);
          this.newDiscount.name = '';
          this.newDiscount.type_id = 0;
          this.newDiscount.amount = '';
          this.newDiscount.discount_unit_type_id = 1;
          this.addingNewDiscountExpense = false;
          toastr.success('Successfully saved discount');
          this.sendMovingContractEmail();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
          toastr.error('Error saving discount', '', { timeOut: 0 });
        });
    },
    saveEditedDiscount(index, id) {
      const edited = { ...this.discounts.find(el => el.id === id) };
      axios
        .put(`job-discounts/${id}`, edited)
        .then(() => {
          this.$set(this.editableExpenseDiscount, index, false);
          toastr.success('Successfully updated discount');
          this.getDiscounts();
          this.sendMovingContractEmail();
        })
        .catch(() => {
          toastr.error('Error updating discount', '', { timeOut: 0 });
        });
    },
    saveEditedExpense(index, expense) {
      if (expense.type_id === 2) {
        expense.name = 'Tips (Cash)';
      } else if (expense.type_id === 3) {
        expense.name = 'Tips (Credit card)';
      }
      axios
        .put(`job-expenses/${expense.id}`, expense)
        .then(() => {
          this.$set(this.editableExpenseAddition, index, false);
          this.$set(this.editableExpenseDiscount, index, false);
          toastr.success('Successfully updated expense');
          this.getExpenses();
          this.sendMovingContractEmail();
        })
        .catch(() => {
          toastr.error('Error updating expense', '', { timeOut: 0 });
        });
    },
    saveExpense(typeId, isTip) {
      this.newExpense.job_id = this.$route.params.id;
      if (!isTip) {
        this.newExpense.type_id = typeId;
      } else if (isTip && this.newExpense.type_id === 2) {
        this.newExpense.name = 'Tips (Cash)';
      } else {
        this.newExpense.name = 'Tips (Credit card)';
      }
      axios
        .post(`job-expenses`, { ...this.newExpense })
        .then(res => {
          this.$set(this.expenses, this.expenses.length, res.data.data);
          this.newExpense.name = '';
          this.newExpense.type_id = 0;
          this.newExpense.amount = '';
          this.addingNewAdditionalExpense = false;
          this.addingNewDiscountExpense = false;
          this.addingNewMoverTips = false;
          toastr.success('Successfully saved expense');
          this.sendMovingContractEmail();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
          toastr.error('Error saving expense', '', { timeOut: 0 });
        });
    },
    saveJobTime(jobTime) {
      if (this.isActive || this.$_can('jobs.completed.update')) {
        this.buttonDisabled = true;
        this.loadingButton = true;
        setTimeout(() => {
          axios
            .patch(`jobs/${this.$route.params.id}/job-time`, {
              job_time: jobTime,
            })
            .then(() => {
              toastr.success('Successfully updated job');
              this.sendMovingContractEmail();
            })
            .catch(err => {
              this.errors.record(err.response.data.error);
            })
            .finally(() => {
              this.loadingButton = false;
              this.buttonDisabled = false;
            });
        }, 800);
      }
    },
    saveNote() {
      axios
        .post(`jobs/${this.$route.params.id}/notes`, {
          note: this.job.note,
          user_id: this.user.id,
        })
        .then(() => {
          toastr.success('Successfully saved note');
          this.editNote = false;
          this.getJob();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    selectedForeman() {
      this.$set(
        this.assign,
        'movers',
        this.assign.movers.filter(mover => mover.id !== this.assign.foreman),
      );
    },
    sendAutomaticMessagesMethod(value) {
      this.sendAutomaticMessages = value;
    },
    sendContractEmail() {
      axios
        .post(`jobs/${this.job.id}/mails/contract`)
        .then(() => {
          toastr.success('Successfully sent pre-agreement email');
          this.getJob();
        })
        .catch(err => {
          if (err.response.data.error.contract) {
            toastr.error(err.response.data.error.contract);
          } else {
            toastr.error(err.response.data.error);
          }
        });
    },
    sendMessages(mover = null, index = null) {
      if (index !== null) {
        this.$set(this.loadingButtonMovers, index, true);
      }
      this.loadingButton = true;
      if (mover) {
        this.selectedMoverId = mover.id;
      }
      const data = {};
      if (this.selectedMoverId) {
        data.mover_ids = [this.selectedMoverId];
      }
      axios
        .post(`movers/text-messages/${this.job.id}`, data)
        .then(() => {
          this.getJob();
          if (this.selectedMoverId) {
            toastr.success('Request for confirmation successfully sent to mover');
          } else {
            toastr.success('Request for confirmation successfully sent to all movers');
          }
        })
        .catch(err => {
          if (err.response.data) {
            if (err.response.data.error.company_phone) {
              toastr.error(err.response.data.error.company_phone);
            }
            this.errors.record(err.response.data.error);
          }
        })
        .finally(() => {
          this.selectedMoverId = null;
          this.buttonDisabled = false;
          this.loadingButton = false;
          if (index !== null) {
            this.loadingButtonMovers[index] = false;
          }
          this.sendAutomaticMessages = false;
        });
    },
    sendMovingContractEmail() {
      if (this.job.status.name === 'Completed') {
        axios
          .post(`jobs/${this.job.id}/mails/moving-contract`)
          .then(() => {
            if (!this.emailConfirmationModalShown && !this.job.send_contract_at) {
              this.emailConfirmationModalShown = true;
              this.showEmailConfirmationModal = true;
            }
            this.getJob();
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          });
      } else {
        this.getJob();
      }
    },
    setCustomerModalStep(step) {
      this.customerModalStep = step;
    },
    setJobTabStep(value) {
      this.jobTabStep = value;
    },
    setCarrier(carrierId) {
      this.$set(this.job, 'carrier_id', carrierId);
      this.errors.clear('availability');
    },
    stopTimeTracking() {
      axios
        .put(`jobs/${this.$route.params.id}`, { status_id: 41 })
        .then(() => {
          toastr.success('Successfully stopped time tracking job');
          this.getJob();
        })
        .catch(err => {
          if (err.response.data.error.status_id) {
            toastr.error(err.response.data.error.status_id);
          }
          this.errors.record(err.response.data.error);
        });
    },
    toggleEmailConfirmationModal() {
      this.showEmailConfirmationModal = !this.showEmailConfirmationModal;
    },
    toggleTransactionsModal() {
      this.newTransaction = !this.newTransaction;
    },
    reassignCarrier() {
      axios
        .patch(`jobs/${this.job.id}`, { carrier_id: this.job.carrier_id })
        .then(() => {
          this.getJob();
          toastr.success('Successfully reassigned job');
          this.showCarrierReassignModal = false;
          this.errors.clear('availability');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassignUser() {
      axios
        .patch(`jobs/${this.job.id}/cluster-user`, { cluster_user_id: this.assigneeId })
        .then(() => {
          this.getJob();
          toastr.success('Successfully reassigned job');
          this.showUserReassignModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassignUserModal() {
      axios
        .get(`clusters/users/sales`)
        .then(res => {
          res.data.data.forEach(assignee => {
            assignee.name = `${assignee.first_name} ${assignee.last_name}`;
          });
          this.assignees = res.data.data;
        })
        .then(() => {
          this.showUserReassignModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    removeCashDiscount() {
      axios
        .delete(`/job-discounts/${this.job.id}/cash`)
        .then(() => {
          this.getJob();
          toastr.success('Successfully removed Cash Discount!');
          this.showClearCashDiscountModal = false;
        })
        .catch(() => {
          toastr.error('Failed clear cash discount.');
        });
    },
    removeContact(index) {
      this.job.customer.contacts.splice(index, 1);
    },
    removeDiscount(index, id) {
      axios
        .delete(`job-discounts/${id}`)
        .then(() => {
          toastr.success('Successfully removed discount');
          this.discounts.splice(this.discounts.findIndex(el => el.id === id), 1);
          this.sendMovingContractEmail();
          this.getDiscounts();
        })
        .catch(() => {
          toastr.error('Error removing discount', '', { timeOut: 0 });
        });
    },
    removeExpense(index, id) {
      axios
        .delete(`job-expenses/${id}`)
        .then(() => {
          toastr.success('Successfully removed expense');
          this.expenses.splice(this.expenses.findIndex(el => el.id === id), 1);
          this.sendMovingContractEmail();
          this.getExpenses();
        })
        .catch(() => {
          toastr.error('Error removing expense', '', { timeOut: 0 });
        });
    },
    requestReview(resend = false) {
      this.reviewRequested = true;
      axios
        .post(`jobs/${this.job.id}/request-review`)
        .then(() => {
          this.getJob();
          if (resend) {
            toastr.success('Successfully resent review request');
          } else {
            toastr.success('Successfully requested review');
          }
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    restoreStatus() {
      axios
        .patch(`jobs/${this.job.id}/restore-status`)
        .then(() => {
          this.getJob();
          toastr.success('Successfully restored job');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    updateJob() {
      axios
        .put(`jobs/${this.$route.params.id}`, { is_small: this.job.is_small })
        .then(() => {
          // toastr.success('Successfully completed job')
          // this.getJob()
        })
        .catch(err => {
          if (err.response.data.error.status_id) {
            toastr.error(err.response.data.error.status_id);
          }
          this.errors.record(err.response.data.error);
        });
    },
    updateJobStatusChange(id, statusId) {
      this.changeStatus(id, statusId);
      this.updateJob();
    },
  },
  beforeRouteLeave(to, from, next) {
    delete axios.defaults.headers.q;
    next();
  },
};
</script>
<style lang="scss">
.multiselect__option:after {
  right: 30px !important;
  position: absolute !important;
  top: 15px !important;
  font-size: 14px !important;
}
.small-simple-select {
  .simple-select-header {
    .simple-select-input {
      margin-top: -5px;
    }
    .simple-select-caret {
      top: -5px !important;
      left: 72% !important;
    }
    .simple-select-caret__open {
      transition: none !important;
      transform: rotate(90deg) !important;
      top: -5px !important;
      left: 72% !important;
      padding: 0 12px !important;
    }
  }
}
.close-tips {
  position: absolute;
  top: 3px;
  right: 3%;
}

.simple-select-options {
  z-index: 1000;
}

.small-simple-select .simple-select-options {
  top: 40px !important;
}

.small-simple-select .simple-select-select-text {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsEdit.vue